module.exports = __webpack_public_path__ + "assets/img/17_955_big.6327851a.jpg";